import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconStatusComponent } from './components/icon-status.component';

@NgModule({
  declarations: [IconStatusComponent],
  imports: [CommonModule],
  exports: [IconStatusComponent],
})
export class IconStatusModule {}
